module.exports = __webpack_public_path__ + "media/images/pc/page_common/purpose_plan-7429f262efe96ad97e99987a71a50e5b.png";